import TeraLogo from "../../../assets/images/tera-logo-branco.png"

export const Logo = ({ width, height, marginRight }) => {
  return <img src={TeraLogo} alt="Tera Logo" style={{ width, height, marginRight }} />
}
